var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { CFNumberBadge } from '../../components';
import { commonAttrs } from '../../utils';
import { CFTabElements } from './Tab.styles';
export const CFTabCore = (_a, ref) => {
    var { active = false, alternateTheme = false, badge, customTheme, id, label, withActiveBorder = true } = _a, rest = __rest(_a, ["active", "alternateTheme", "badge", "customTheme", "id", "label", "withActiveBorder"]);
    const { Label, LabelWrapper, Root } = CFTabElements;
    const tabRef = useRef(null);
    useImperativeHandle(ref, () => {
        var _a, _b;
        return {
            id,
            left: (_a = tabRef.current) === null || _a === void 0 ? void 0 : _a.offsetLeft,
            width: (_b = tabRef.current) === null || _b === void 0 ? void 0 : _b.offsetWidth,
        };
    });
    return (React.createElement(Root, Object.assign({ "$active": active, "$alternateTheme": alternateTheme, "$customTheme": customTheme, id: id, ref: tabRef }, commonAttrs(rest)),
        React.createElement(LabelWrapper, { "$active": active, "$alternateTheme": alternateTheme, "$customTheme": customTheme, "$withActiveBorder": withActiveBorder },
            React.createElement(Label, { "$active": active, "$alternateTheme": alternateTheme, "$customTheme": customTheme }, label),
            badge && (React.createElement(CFNumberBadge, Object.assign({}, badge, { style: { bottom: 0.5, position: 'relative' } }))))));
};
export const CFTab = forwardRef(CFTabCore);
